import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const DashboardSection: React.FC<{ userName?: string }> = ({ userName }) => (
  <Box>
    <Typography variant="h4" fontWeight={700} sx={{ mb: 2 }}>Dashboard</Typography>
    <Paper elevation={0} sx={{ p: 4, border: '1px solid', borderColor: 'divider', borderRadius: 3 }}>
      <Typography variant="h5" fontWeight={700}>Livaxu Sales Panel</Typography>
      <Typography color="text.secondary" sx={{ mt: 1 }}>Hoş geldiniz, {userName}.</Typography>
      <Typography color="text.secondary" sx={{ mt: 2 }}>Toplantılarınızı, saha raporlarınızı ve coğrafi ekibinizi sol menüden yönetebilirsiniz.</Typography>
    </Paper>
  </Box>
);

export default DashboardSection;
